module.exports = __webpack_public_path__ + "img/yh_17.09572446.png";